<template>
  <td
    :class="{
      'red--text': value < 0,
      [`bg-${Math.ceil(Math.min(value, 1) * 10)}`]: true
    }"
  >
    {{value | percent(1)}}
  </td>
</template>

<script>
import { percent} from "@/filters";

export default {
  name: "SensitivityCell",
  filters: { percent },
  props: ["value"]
}
</script>

<style scoped lang="scss">
@function tint($color, $percentage) {
  @return mix($color, white, $percentage);
}

.bg-1 {
  background-color: tint(#1E5AAA, 10);
}

.bg-2 {
  background-color: tint(#1E5AAA, 20);
}

.bg-3 {
  background-color: tint(#1E5AAA, 30);
}

.bg-4 {
  background-color: tint(#1E5AAA, 40);
}

.bg-5 {
  background-color: tint(#1E5AAA, 50);
}

.bg-6 {
  background-color: tint(#1E5AAA, 60);
}

.bg-7 {
  background-color: tint(#1E5AAA, 70);
}

.bg-8 {
  background-color: tint(#1E5AAA, 80);
}

.bg-9 {
  background-color: tint(#1E5AAA, 90);
}

.bg-10 {
  color: white;
  background-color: tint(#1E5AAA, 100);
}
</style>